import { render, staticRenderFns } from "./PopularGames.vue?vue&type=template&id=64788b48&scoped=true&"
import script from "./PopularGames.vue?vue&type=script&lang=js&"
export * from "./PopularGames.vue?vue&type=script&lang=js&"
import style0 from "./PopularGames.vue?vue&type=style&index=0&id=64788b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64788b48",
  null
  
)

export default component.exports